//import Rating from "../../component/sidebar/rating";

const title = "Indian Classical Singing & Raaga Fundamentals";
const desc = "Learn Raagas, Swaras, Alankaras, and traditional Indian vocal techniques. Perfect for beginners and intermediate learners!";
const author = "Vishnu Priya";
const reviewCount = "18 reviews";
const videoLink = "https://www.youtube-nocookie.com/embed/jP649ZHA8Tg";

const categoryList = [
    {
        link: '#',
        text: 'Indian Classical',
        className: 'course-cate',
    },
    {
        link: '#',
        text: '22 Lessons',
        className: 'course-offer',
    },
];

const Classical = () => {
    return (
        <div className="pageheader-section style-2">
            <div className="container">
                <div className="row justify-content-center justify-content-lg-between align-items-center flex-row-reverse">
                    <div className="col-lg-7 col-12">
                        <div className="pageheader-thumb">
                            <img src="assets/images/art/ClassicalSing.png" alt="Indian Classical Singing" className="w-100" />
                            <a href={videoLink} className="video-button popup" target="_blank" rel="noopener noreferrer">
                                <i className="icofont-ui-play"></i>
                            </a>
                        </div>
                    </div>
                    <div className="col-lg-5 col-12">
                        <div className="pageheader-content">
                            <div className="course-category">
                                {categoryList.map((val, i) => (
                                    <a href={val.link} className={val.className} key={i}>{val.text}</a>
                                ))}
                            </div>
                            <h2 className="phs-title">{title}</h2>
                            <p className="phs-desc">{desc}</p>
                            <div className="phs-thumb">
                                <img src="assets/images/course/author/02.jpg" alt={author} />
                                <span>{author}</span>
                                <div className="course-reiew">
                                    {/* Uncomment if Rating component is available */}
                                    {/* <Rating /> */}
                                    <span className="ratting-count">{reviewCount}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Classical;
